
import StringUtils from '../../utils/string-utils';

export default class FormPopulator {

    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el;
    }

    async populateForm(order) {
        const orderNumber = order?.orderId;
        this.populateAddressFromOrder(order);

        const data = await HONDA.MyAccount2.client.getSavedFinanceApplication(orderNumber);
        const hasPartialSave = !!(data?.dateOfBirth);
        if (hasPartialSave) {
            this.parent.showLoader();
            this.parent.views.eligibility.setEligible(true);
            this.populateFromPartialSave(data);
            this.router.update('form');
            await this.parent.views.form.progressSections();
            this.parent.hideLoader();
        }
    }

    setField(name, value) {
        if(value) {
            const els = this.el.querySelectorAll(`[name="${name}"]`) ?? [];
            els.forEach((el) => {
                if(el.type === 'checkbox' || el.type === 'radio' ) {
                    el.checked = el.value === value;

                } else if(el.tagName === 'SELECT') {
                    el.value = value;
                    if(!el.value) {
                         el.value = [...(el.options ?? '[]')].find((option) => StringUtils.equalsIgnoreCase(option.textContent, value))?.value;
                    }
                } else {
                    el.value = value;
                }

                el.dispatchEvent(new Event('change'));
            });
        }
    }

    populateAddressFromOrder(order) {
        this.setField('address0_postCode', order?.billingAddress?.postalCode);
    }

    populateFromPartialSave(data) {
        this.setField('isContactableViaEmail', data.contactConsent?.isContactableViaEmail);
        this.setField('isContactableViaPost', data.contactConsent?.isContactableViaEmail);
        this.setField('isContactableViaPhone', data.contactConsent?.isContactableViaEmail);
        this.setField('isContactableViaSMS', data.contactConsent?.isContactableViaEmail);
        this.setField('futurecircumstanceYN', data.futurecircumstanceYN);
        this.setField('futurecircumstanceNote', data.futurecircumstancesnote);
        this.setField('title', data.salutation);
        this.setField('firstName', data.firstName);
        this.setField('initial', data.initial);
        this.setField('lastName', data.surname);
        this.setField('previousName', data.previousName);
        this.setField('emailAddress', data.emails?.[0]);
        this.setField('mobilePhoneNumber', data.communication?.phones?.find((p) => p.phoneTypeCode === 'MOB')?.phoneNumber);
        this.setField('homePhoneNumber', data.communication?.phones?.find((p) => p.phoneTypeCode === 'HO')?.phoneNumber);
        this.setField('dateOfBirth', data.dateOfBirth?.split('T')?.[0]);
        this.setField('residencyStatus', data.residencyStatus);
        this.setField('maritalStatus', data.maritalStatus);
        this.setField('nationality', data.nationality);
        this.setField('licenceType', data.licenceTypeCode);
        this.setField('drivingLicenceNumber', data.licenceNumber);
        this.setField('connectedparty', data.connectedparty);
        this.setField('connectedpartydetails', data.connectedpartydetails);
        this.setField('numberOfDependents', data.numberOfDependents);
        this.setField('grossAnnualIncome', data.grossAnnualIncome);
        this.setField('totalMonthlyHousingExpenditure', data.totalMonthlyHousingExpenditure);
        this.setField('totalExistingCreditCommitments', data.totalExistingCreditCommitments);
        this.setField('totalOtherExpenditure', data.totalOtherExpenditure);

        const address0 = data.addresses?.find((address) => address.addressTypeDesc === 'Current');
        if(address0) {
            this.setField('address0_postCode', address0.zipPostal);
            this.setField('address0_addressLine1', address0.suiteNumber);
            this.setField('address0_addressLine2', address0.buildingName);
            this.setField('address0_streetNumber', address0.streetNumber);
            this.setField('address0_street', address0.streetName);
            this.setField('address0_town', address0.city);
            this.setField('address0_county', address0.county);
            this.setField('address0_yearsAtAddress', address0.yearsAtAddress);
            this.setField('address0_monthsAtAddress', address0.monthsAtAddress);
        }

        const address1 = data.addresses?.find((address) => address.addressTypeDesc === 'Previous');
        if(address1) {
            this.setField('address1_postCode', address1.zipPostal);
            this.setField('address1_addressLine1', address1.suiteNumber);
            this.setField('address1_addressLine2', address1.buildingName);
            this.setField('address1_streetNumber', address1.streetNumber);
            this.setField('address1_street', address1.streetName);
            this.setField('address1_town', address1.city);
            this.setField('address1_county', address1.county);
            this.setField('address1_yearsAtAddress', address1.yearsAtAddress);
            this.setField('address1_monthsAtAddress', address1.monthsAtAddress);
        }

        const address2 = data.addresses?.find((address) => address.addressTypeDesc === 'Previous Address 2');
        if(address2) {
            this.setField('address2_postCode', address2.zipPostal);
            this.setField('address2_addressLine1', address2.suiteNumber);
            this.setField('address2_addressLine2', address2.buildingName);
            this.setField('address2_streetNumber', address2.streetNumber);
            this.setField('address2_street', address2.streetName);
            this.setField('address2_town', address2.city);
            this.setField('address2_county', address2.county);
            this.setField('address2_yearsAtAddress', address2.yearsAtAddress);
            this.setField('address2_monthsAtAddress', address2.monthsAtAddress);
        }

        const employer0 = data.employers?.filter((employer) => employer.employmentPeriodId === '1')?.[0];
        if(employer0) {
            this.setField('employer0_employmentType', employer0.employmentTypeCode);
            this.setField('employer0_industryCode', employer0.industryCode);
            this.setField('employer0_occupationDescription', employer0.occupationDesc);
            this.setField('employer0_employerName', employer0.employerName);
            this.setField('employer0_yearsAtEmployer', employer0.yearsWithEmployer);
            this.setField('employer0_monthsAtEmployer', employer0.monthsWithEmployer);
        }

        const employer0Address = data.addresses?.filter((address) => address.addressTypeDesc === 'Current Employment')?.[0];
        if(employer0Address) {
            this.setField('employer0_postCode', employer0Address.zipPostal);
            this.setField('employer0_addressLine1', employer0Address.suiteNumber);
            this.setField('employer0_addressLine2', employer0Address.buildingName);
            this.setField('employer0_streetNumber', employer0Address.streetNumber);
            this.setField('employer0_street', employer0Address.streetName);
            this.setField('employer0_town', employer0Address.city);
            this.setField('employer0_county', employer0Address.county);
        }

        const employer1 = data.employers?.filter((employer) => employer.employmentPeriodId === '2')?.[0];
        if(employer1) {
            this.setField('employer1_employmentType', employer1.employmentTypeCode);
            this.setField('employer1_industryCode', employer1.industryCode);
            this.setField('employer1_occupationDescription', employer1.occupationDesc);
            this.setField('employer1_employerName', employer1.employerName);
            this.setField('employer1_yearsAtEmployer', employer1.yearsWithEmployer);
            this.setField('employer1_monthsAtEmployer', employer1.monthsWithEmployer);
        }

        const employer1Address = data.addresses?.filter((address) => address.addressTypeDesc === 'Previous Employment')?.[0];
        if(employer1Address) {
            this.setField('employer1_postCode', employer1Address.zipPostal);
            this.setField('employer1_addressLine1', employer1Address.suiteNumber);
            this.setField('employer1_addressLine2', employer1Address.buildingName);
            this.setField('employer1_streetNumber', employer1Address.streetNumber);
            this.setField('employer1_street', employer1Address.streetName);
            this.setField('employer1_town', employer1Address.city);
            this.setField('employer1_county', employer1Address.county);
        }

        const bankDetails = data.banks?.[0];
        if(bankDetails) {
            this.setField('bank0_accountName', bankDetails.accountName);
            this.setField('bank0_accountNumber', bankDetails.accountNumber);
            this.setField('bank0_sortCode', bankDetails.bankSortCode);
            this.setField('bank0_bankName', bankDetails.name);
            this.setField('bank0_yearsAtBank', bankDetails.yearsWithBank);
            this.setField('bank0_monthsAtBank', bankDetails.monthsWithBank);
        }

        const bank0Address = data.addresses?.find((address) => address.addressTypeDesc === 'Bank Address');
        if(bank0Address) {
            this.setField('bank0_postCode', bank0Address.zipPostal);
            this.setField('bank0_street', bank0Address.streetName);
            this.setField('bank0_town', bank0Address.city);
            this.setField('bank0_county', bank0Address.county);
        }

    }
}
